<template>
  <div class="main_profile_wrapper main_task_details_page_wrapper">
    <div class="main_info_wrapper mb-5">
      <div class="info">
        <img
          class="img"
          src="../../../assets/new-theme/profile/Image wrap.png"
          alt=""
        />
      </div>
      <div class="info_data">
        <div class="wrap_one">
          <div class="main_user_img_wrapper">
            <img class="user_img" :src="image" alt="user image" />
          </div>
          <div>
            <span class="name d-block"
              >{{ userData.first_name }} {{ userData.last_name }}</span
            >
            <span class="email d-block">{{ userData.email }}</span>
          </div>
        </div>
        <!-- User Type -->
        <div class="buttons_links">
          <button class="btn_1" @click="toggleModalUserType">
            <img
              class="img"
              src="../../../assets/new-theme/profile/target-04.png"
              alt=""
            />
            <span v-if="userData.classification == 'Bridge'">{{
              localization("Bridge Learner")
            }}</span>
            <span v-if="userData.classification == 'Dynamic'">{{
              localization("Dynamic Learner")
            }}</span>
            <span v-if="userData.classification == 'Strong-Willed Learner'">{{
              localization("Strong-Willed Learner")
            }}</span>
            <div class="learn_more">
              <span class="color more">{{ localization("Learn more") }}</span>
              <img
                class="img"
                src="../../../assets/new-theme/profile/arrow-right.png"
                alt=""
              />
            </div>
          </button>
        </div>
      </div>
    </div>

    <!-- Start Patterns -->
    <UserPattern :userScore="userScore"></UserPattern>
    <!-- End Patterns -->

    <!-- Use Your Learning Patterns -->
    <div class="learner_patterns_wrapper hide_element_while_printing">
      <div class="titles_wrap">
        <h2 class="main_title ">{{ localization("Steps to personalize your profile") }}</h2>
        <div class="print_share_buttons">
          <button class="btn_2" @click="printPlp()">
            <img
              class="img"
              src="../../../assets/new-theme/profile/printer.png"
              alt=""
            />
            <span>
              {{ localization("Print") }}
            </span>
          </button>
          <button class="btn_2" @click="toggleModalShare()">
            <img
              class="img"
              src="../../../assets/new-theme/profile/share-07.png"
              alt=""
            />
            <span>{{ localization("Share") }}</span>
          </button>
        </div>
      </div>
      <!-- <p class="mb-0 text">
        {{ localization("This is the beginning of understanding yourself and learning to take responsibility for using your Patterns with intention.") }}
      </p> -->
      <div class="main_cards mt-3">
        <div class="card_item">
          <div class="mb-3">
            <img
              class="img icon_img"
              src="../../../assets/new-theme/profile/check-2.png"
              alt=""
            />
          </div>
          <div class="mb-4">
            <span class="title mb-2 d-block">
              {{ localization("Select phrases that describe you") }}
            </span>
            <p class="mb-0 description">
              {{ localization("Read the statement under each learning pattern carefully and select phrases that perfectly describe you.") }}
            </p>
          </div>
        </div>
        <div class="card_item">
          <div class="mb-3">
            <img
              class="img icon_img"
              src="../../../assets/new-theme/profile/plus-back.png"
              alt=""
            />
          </div>
          <div class="mb-4">
            <span class="title mb-2 d-block">
              {{ localization("Add your own statement") }}
            </span>
            <p class="mb-0 description">
              {{ localization("If you want to describe yourself in a more accurate statement, add your own personalized statement.") }}
            </p>
          </div>
        </div>
        <div class="card_item">
          <div class="mb-3">
            <img
              class="img icon_img"
              src="../../../assets/new-theme/profile/share-2.png"
              alt=""
            />
          </div>
          <div class="mb-4">
            <span class="title mb-2 d-block">
              {{ localization("Print or share it with it with others") }}
            </span>
            <p class="mb-0 description">
              {{ localization("Print or share it with your teacher, instructor, classmates, colleagues, or even for a job inerview.") }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- Use Your Learning Patterns -->

    <!-- Start Personalize your profile & Collapse Items -->
    <div class="main_profile_personalize_and_collapse">
      <h2 class="main_title hide_element_while_printing">
        {{ localization("Personalize your profile") }}
      </h2>
      <p class="mb-0 description hide_element_while_printing">
        {{ localization("Your choices provide insights about how you learn, work, and interact with others.") }}
      </p>

      <el-collapse
        class="mt-3 customization_for_collapse"
        v-model="panel"
        multiple
        v-if="userAttributes"
      >
        <div
          class="main_child "
          v-for="(attribute, i) in userAttributes"
          :key="i"
          :style="`border : 2px solid ${getProgressColor(i)}`"
        >
          <!-- Start Collapse Title -->
          <el-collapse-item
            :name="`${i}`"
            class=""
            :class="{ break_section: i == 'Precision' }"
          >
            <template #title>
              <div class="custom_header_of_collapse">
                <img
                  src="@/assets/new-theme/attributes-images/sequence.png"
                  alt="sequence"
                  v-if="i == 'Sequence'"
                />
                <img
                  src="@/assets/new-theme/attributes-images/precision.png"
                  alt="precision"
                  v-if="i == 'Precision'"
                />
                <img
                  src="@/assets/new-theme/attributes-images/technical_reasoning.png"
                  alt="technical_reasoning"
                  v-if="i == 'Technical Reasoning'"
                />
                <img
                  src="@/assets/new-theme/attributes-images/confluence.png"
                  alt="confluence"
                  v-if="i == 'Confluence'"
                />
                <span class="title_word">{{ localization(i) }} - {{ localization(patternKey(i)) }}</span>
              </div>
            </template>
            <!-- End Collapse Title -->
            <!-- Start Checkboxes -->
            <div class="p-3">
              <el-collapse class="collapse_checkboxes">
                <div
                  class="checkboxes_wrapper"
                  v-for="(item, index) in attribute"
                  :key="index"
                >
                  <el-checkbox-group class="" v-model="selected" v-if="item">
                    <el-checkbox
                      :label="item.id"
                      :checked="Array.isArray(selected) && selected.includes(item.id)"
                      @change="updateSelectedAttributes"
                      :disabled="!isAuthEqualUser"
                      :class="{
                        'd-none': item.title < 1
                      }"
                    >
                      {{ item.title }}
                    </el-checkbox>
                  </el-checkbox-group>
                  <audio controls id="audio" class="d-none">
                    <source id="audio-source" type="audio/mp3" />
                  </audio>

                  <div class="d-flex">
                    <span
                      class="span_img_wrapper mt-1"
                      role="button"
                      @click="text_speech_audio(item.title)"
                    >
                      <img
                        src="../../../assets/new-theme/attributes-images/volume.png"
                        alt="volume"
                      />
                    </span>

                    <span class="mx-2" v-if="item.user_id && isAuthEqualUser" >
                      <a
                        v-tooltip.top-center=" `${localization('Edit')}` "
                        class="btn btn-warning btn-simple btn-link"
                        @click="ToggleStatementModalForEdit(item)"
                      >
                        <img
                          src="@/assets/new-theme/edit.png"
                          alt="edit-05-inactive"
                        />
                      </a>
                      <a
                        v-tooltip.top-center=" `${localization('Delete')}` "
                        @click="deleteCustomAttribute(item.id)"
                      >
                        <img
                          role="button"
                          src="@/assets/new-theme/delete-button-table.png"
                          alt="delete"
                        />
                      </a>
                    </span>

                  </div>
                </div>
                <div
                  class="your_own_statement hide_element_while_printing"
                  @click="toggleModalAddStatement(i, attribute)"
                  v-if="isAuthEqualUser"
                >
                  <img
                    role="button"
                    src="@/assets/new-theme/profile/plus.png"
                    alt="plus"
                  />
                  <span role="button">
                    {{ localization("Add your own personalized statement") }}
                  </span>
                </div>
              </el-collapse>
            </div>
            <!-- End Checkboxes  -->
          </el-collapse-item>
        </div>
      </el-collapse>
    </div>
    <!-- End Personalize your profile & Collapse Items -->

    <div class="learner_patterns_wrapper">
      <h2 class="main_title ">
        {{localization("Use Your Learning Patterns")}}
      </h2>
      <p class="mb-0 text">
        {{localization("Add your own task and discover what patterns are needed to successfully complete it.")}}
      </p>
      <div class="main_cards two_cards mt-3">
        <div class="card_item">
          <div class="mb-3">
            <img
              class="img icon_img"
              src="../../../assets/new-theme/profile/book.png"
              alt=""
            />
          </div>
          <div class="mb-4">
            <span class="title mb-2 d-block">
              {{localization("Study-related task")}}
            </span>
            <p class="mb-0 description">
              {{localization("Add new tasks in math, reading, writing, study skills, science, social studies, etc")}}...
            </p>
          </div>
          <div>
            <button class="lci_btn " @click="ToggleTaskModal">
              <img
                class="img"
                src="../../../assets/new-theme/profile/plus.png"
                alt=""
              />
              <span>
                {{localization("Add a new study-related task")}}
              </span>
            </button>
          </div>
        </div>
        <div class="card_item">
          <div class="mb-3">
            <img
              class="img icon_img"
              src="../../../assets/new-theme/profile/wallet.png"
              alt=""
            />
          </div>
          <div class="mb-4">
            <span class="title mb-2 d-block">
              {{localization("Work-related task")}}
            </span>
            <p class="mb-0 description">
              {{localization("Add new tasks in time management, team interaction, meeting preparation, etc")}}...
            </p>
          </div>
          <div>
            <button class="lci_btn " @click="ToggleTaskModal2">
              <img
                class="img"
                src="../../../assets/new-theme/profile/plus.png"
                alt=""
              />
              <span>
                {{localization("Add a new work-related task")}}
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Start How to use your Personal Learning Profile (PLP)? -->
    <div class="how_to_use hide_element_while_printing">
      <h2 class="main_title ">
        {{ localization("How to use your Personal Learning Profile (PLP)?") }}
      </h2>
      <p class="mb-0 description">
        {{ localization("Print or share it with your teacher, instructor, classmates, colleagues, or even for a job inerview.") }}
      </p>

      <div class="print_share_buttons mt-4">
        <button class="btn_2" @click="printPlp()">
          <img
            class="img"
            src="../../../assets/new-theme/profile/printer.png"
            alt=""
          />
          <span>
            {{ localization("Print your PLP") }}
          </span>
        </button>
        <button class="btn_2" @click="toggleModalShare()">
          <img
            class="img"
            src="../../../assets/new-theme/profile/share-07.png"
            alt=""
          />
          <span>
            {{ localization("Share your PLP") }}
          </span>
        </button>
      </div>
    </div>
    <!-- End How to use your Personal Learning Profile (PLP)? -->

    <!-- Start Modal User Type -->
    <el-dialog
      :visible.sync="showHideModalUserType"
      top="4vh"
      width="45%"
      :show-close="false"
      class="user_modal"
    >
      <div class="user_modal_type w-100">
        <img
          class="img"
          src="../../../assets/new-theme/profile/target-04.png"
          alt=""
        />

        <div>
          <h4 class="modal_title">
            <span v-if="userData.classification == 'Bridge'">{{
              localization("Bridge Learner")
            }}</span>
            <span v-if="userData.classification == 'Dynamic'">{{
              localization("Dynamic Learner")
            }}</span>
            <span v-if="userData.classification == 'Strong-Willed Learner'">{{
              localization("Strong-Willed Learner")
            }}</span>
          </h4>
        </div>
        <div class="description_type">
          <p class="text_type" v-if="userData.classification == 'Bridge'">
            {{ localization("The Bridge Learner uses all Patterns at a Use as Needed level. Your Patterns serve a helpful role by leading from the middle. Bridge learners are team catalysts. The Bridge learner can close the gap of understanding between learners who have Use First and Avoid Patterns.") }}
          </p>
          <p class="text_type" v-if="userData.classification == 'Dynamic'">
            <!-- {{ localization("dynamic tool tip") }} -->
            <ul>
              <li class="mb-2">
                {{ localization("Dynamic is the combination of Learning Patterns that uses at least one Pattern at the Use First level, while the remaining ones are any combination of another Use First, Use as Needed, or Avoid.") }}
              </li>
              <li class="mb-2">
                {{ localization("You experience yourself shifting from the use of one Pattern to another, particularly when you move from your Use First Patterns to those you Avoid.") }}
              </li>
              <li class="mb-2">
                {{ localization("As a Dynamic learner, you can relate to others well and understand how they use their Learning Patterns.") }}
              </li>
              <li class="mb-2">
                {{ localization("You can identify when a colleague or supervisor is shifting from one Pattern to another and are able to sense when others in your work setting are having their Pattern needs ignored.") }}
              </li>
            </ul>
          </p>
          <p
            class="text_type"
            v-if="userData.classification == 'Strong-Willed Learner'"
          >
            {{ localization("The Strong-Willed Learner uses three or more Patterns at the Use First level. Strong-Willed learners seek opportunities to lead rather than be led. Your Patterns would have you prefer to control the plan, the ideas, the talks, the decisions, the processes, and the outcomes and do it all yourself. Understanding how your Patterns affect those around you is particularly important when you are a Strong-Willed Learner.") }}
          </p>
        </div>
        <!-- <div class="learn_more">
          <span class="color more" role="button">Learn more</span>
          <img
            role="button"
            class="img"
            src="../../../assets/new-theme/profile/arrow-right.png"
            alt=""
          />
        </div> -->
      </div>
    </el-dialog>
    <!-- End Modal User Type -->

    <!--  Start Add new Statement -->
    <el-dialog
      :visible.sync="showHideModalAddStatement"
      top="4vh"
      width="35%"
      :show-close="false"
      class="user_modal statement_modal"
    >
      <div class="user_modal_type w-100">
        <img
          class="img"
          src="../../../assets/new-theme/profile/target-04.png"
          alt=""
        />

        <div>
          <h4 class="modal_title mb-0">
            {{ localization("Add new statement") }} - {{ statementName }}
          </h4>
        </div>
        <div class="description_type">
          <p class="text_type mb-0">
            {{ localization("If you wish to add a more personalized statement to your profile, write it below.") }}
          </p>
        </div>
        <div class="mt-3">
          <p class="desc2">
            {{ localization("The new statement") }}
          </p>
          <textarea
            class="text_area"
            :placeholder="`${localization('Add your new statement here...')}`"
            v-model="payload.title"
          ></textarea>
        </div>
        <div class="lci_modal_buttons mt-4">
          <button
            @click="toggleModalAddStatement()"
            class="lci_btn_modal_cancel "
          >
            {{ localization("Cancel") }}
          </button>
          <button
            @click="addCustomAttribute()"
            class="lci_btn"
            :class="{ save: payload.title }"
            :disabled="!payload.title"
          >
            {{ localization("Confirm") }}
          </button>
        </div>
      </div>
    </el-dialog>
    <!--  End Add new Statement -->

    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      width="600px"
      top="1%"
      custom-class="task-modal global_modal"
      @close="resetForm"
      :close-on-click-modal="false"
    >
      <div class="custom_modal_header">
        <div class="images">
          <img src="@/assets/new-theme/file.png" alt="file" />
          <img
            @click="resetForm"
            class="close_img"
            src="@/assets/new-theme/x-close-modal.png"
            alt="file"
          />
        </div>
        <h3 class="title">
          {{ localization("Add a new study-related task") }}
        </h3>
        <p class="description">
          {{ localization("Add your own task and discover what patterns are needed to successfully complete it.") }}
        </p>
      </div>

      <!-- Task Form -->
      <el-form :model="task" :rules="rules" ref="taskForm" class="task-form">
        <div class="flex justify-content-between" style="gap: 10px">
          <div class="flex-grow-1">
            <!-- Task Name -->
            <el-form-item prop="name">
              <AppInputLabel :text="`${localization('Name your task')}`" :star="true"></AppInputLabel>
              <el-input
                class="new_theme_custom_input"
                v-model="task.name"
                :placeholder="`${localization('Give your task a name')}`"
                clearable
              ></el-input>
            </el-form-item>
          </div>
          <div class="flex-grow-1">
            <!-- Task Topic -->
            <el-form-item prop="topic_id">
              <AppInputLabel :text="`${localization('Task category')}`" :star="true"></AppInputLabel>
              <el-select
                v-model="task.topic_id"
                clearable
                :placeholder="`${localization('Topic')}`"
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in standardTopicsData"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>

        <!-- Task Description -->
        <el-form-item prop="description">
          <AppInputLabel :text="`${localization('Task description')}`" :star="true"></AppInputLabel>
          <el-input
            class="new_theme_custom_input input_with_custom_text_area"
            type="textarea"
            v-model="task.description"
            :placeholder="`${localization('Add task description')}`"
            clearable
          />
        </el-form-item>
      </el-form>
      <div class="or_modal mb-3">
          {{ localization("or") }}
          </div>
      <!-- File Upload Section -->
      <div class="file-upload">
        <el-upload
          class="upload-demo"
          drag
          action=""
          :on-change="handleUploadSuccess"
          :before-upload="beforeUpload"
          :file-list="fileList"
          :auto-upload="false"
          :on-remove="handleRemove"
          :show-file-list="false"
          accept="image/apng, image/jpeg, image/png, image/webp"
          :disabled="loading"
        >
          <div v-if="!loading">
            <img src="@/assets/new-theme/upload.png" alt="upload" />
            <div class="el-upload__text">
              <span class="click_upload">
                {{ localization("Click to upload") }}
                </span>
                {{ localization("or drag and drop") }}
            </div>
            <div class="el-upload__tip">
              {{ localization("Supported") }}: PNG, JPG, (Max 5MB)
            </div>
          </div>
          <div
            class="d-flex spin_modal"
            v-loading="loading"
            element-loading-text="waiting to extract photo..."
          ></div>
        </el-upload>
      </div>

      <!-- Display Uploaded Files with Delete Option -->
      <div v-if="fileList && fileList.length > 0" class="uploaded-files">
        <ul>
          <li v-for="file in fileList" :key="file.name" class="file-item">
            <div class="d-flex" style="gap: 10px">
              <div>
                <img src="@/assets/new-theme/file.png" alt="" />
              </div>
              <div>
                <span class="file-name">{{ file.name }}</span>
                <span class="d-block file_size"
                  >{{ (file.size / 1024).toFixed(2) }} KB</span
                >
              </div>
            </div>
            <i class="el-icon-delete file-delete" @click="removeFile(file)"></i>
          </li>
        </ul>
      </div>

      <!-- Footer Buttons -->
      <div class="lci_modal_buttons mt-4">
        <button @click="resetForm" class="lci_btn_modal_cancel ">
          {{ localization("Cancel") }}
        </button>
        <button @click="submitForm" class="lci_btn save  lci_btn_modal_cancel">
          {{ localization("Confirm") }}
        </button>
      </div>
    </el-dialog>

    <el-dialog
      title=""
      :visible.sync="dialogVisible2"
      width="600px"
      top="1%"
      custom-class="task-modal global_modal"
      @close="resetForm2"
      :close-on-click-modal="false"
    >
      <div class="custom_modal_header">
        <div class="images">
          <img src="@/assets/new-theme/file.png" alt="file" />
          <img
            @click="resetForm2"
            class="close_img"
            src="@/assets/new-theme/x-close-modal.png"
            alt="file"
          />
        </div>
        <h3 class="title">
          {{ localization("Add a new work-related task") }}
        </h3>
        <p class="description">
          {{ localization("Add your own task and discover what patterns are needed to successfully complete it.") }}
        </p>
      </div>

      <!-- Task Form -->
      <el-form :model="task2" :rules="rules2" ref="taskForm2" class="task-form">
        <div class="flex justify-content-between" style="gap: 10px">
          <div class="flex-grow-1">
            <!-- Task Name -->
            <el-form-item prop="name">
              <AppInputLabel :text="`${localization('Name your task')}`" :star="true"></AppInputLabel>
              <el-input
                class="new_theme_custom_input"
                v-model="task2.name"
                :placeholder="`${localization('Give your task a name')}`"
                clearable
              ></el-input>
            </el-form-item>
          </div>
          <div class="flex-grow-1">
            <!-- Task Topic -->
            <el-form-item prop="topic_id">
              <AppInputLabel :text="`${localization('Task category')}`" :star="true"></AppInputLabel>
              <el-select
                v-model="task2.topic_id"
                clearable
                :placeholder="`${localization('Topic')}`"
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in atWorkTasksTopics"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>

        <!-- Task Description -->
        <el-form-item prop="description">
          <AppInputLabel :text="`${localization('Task description')}`" :star="true"></AppInputLabel>
          <el-input
            class="new_theme_custom_input input_with_custom_text_area"
            type="textarea"
            v-model="task2.description"
            :placeholder="`${localization('Add task description')}`"
            clearable
          />
        </el-form-item>
      </el-form>
      <div class="or_modal mb-3">
        or</div>
      <!-- File Upload Section -->
      <div class="file-upload">
        <el-upload
          class="upload-demo"
          drag
          action=""
          :on-change="handleUploadSuccess"
          :before-upload="beforeUpload"
          :file-list="fileList"
          :auto-upload="false"
          :on-remove="handleRemove"
          :show-file-list="false"
          accept="image/apng, image/jpeg, image/png, image/webp"
          :disabled="loading"
        >
          <div v-if="!loading">
            <img src="@/assets/new-theme/upload.png" alt="upload" />
            <div class="el-upload__text">
              <span class="click_upload">
                {{ localization("Click to upload") }}
              </span>
                {{ localization("or drag and drop") }}
            </div>
            <div class="el-upload__tip">
              {{ localization("Supported") }} : PNG, JPG, (Max 5MB)
            </div>
          </div>
          <div
            class="d-flex spin_modal"
            v-loading="loading"
            element-loading-text="waiting to extract photo..."
          ></div>
        </el-upload>
      </div>

      <!-- Display Uploaded Files with Delete Option -->
      <div v-if="fileList && fileList.length > 0" class="uploaded-files">
        <ul>
          <li v-for="file in fileList" :key="file.name" class="file-item">
            <div class="d-flex" style="gap: 10px">
              <div>
                <img src="@/assets/new-theme/file.png" alt="" />
              </div>
              <div>
                <span class="file-name">{{ file.name }}</span>
                <span class="d-block file_size"
                  >{{ (file.size / 1024).toFixed(2) }} KB</span
                >
              </div>
            </div>
            <i class="el-icon-delete file-delete" @click="removeFile(file)"></i>
          </li>
        </ul>
      </div>

      <!-- Footer Buttons -->
      <div class="lci_modal_buttons mt-4">
        <button @click="resetForm2" class="lci_btn_modal_cancel ">
          {{ localization("Cancel") }}
        </button>
        <button @click="submitForm2" class="lci_btn save  lci_btn_modal_cancel">
          {{ localization("Confirm") }}
        </button>
      </div>
    </el-dialog>

    <el-dialog
      title=""
      :visible.sync="statementDialogVisible"
      width="600px"
      top="1%"
      custom-class="task-modal global_modal"
      @close="resetStatementForm"
      :close-on-click-modal="false"
    >
      <div class="custom_modal_header">
        <div class="images">
          <img src="@/assets/new-theme/file.png" alt="file" />
          <img
            @click="resetStatementForm"
            class="close_img"
            src="@/assets/new-theme/x-close-modal.png"
            alt="file"
          />
        </div>
          <h3 class="title">{{ localization('Edit Statement') }}</h3>
          <p class="description">
          </p>
      </div>

      <el-form :model="payload"  class="task-form">
        <el-form-item prop="description">
          <AppInputLabel></AppInputLabel>
          <el-input
            class="new_theme_custom_input input_with_custom_text_area"
            type="textarea"
            v-model="payload.title"
            :placeholder="`${localization('Add task description')}`"
            clearable
          />
        </el-form-item>
      </el-form>

      <!-- Footer Buttons -->
      <div class="lci_modal_buttons mt-4">
        <button @click="resetStatementForm" class="lci_btn_modal_cancel ">
          {{ localization('Cancel') }}
        </button>
        <button @click="submitStatementForm" class="lci_btn save  lci_btn_modal_cancel">
          {{ localization('Confirm') }}
        </button>
      </div>
    </el-dialog>

    <!--  Start Share -->
      <!-- @submit="submitShared" -->
    <ShareModal
      :showHideModalShare.sync="showHideModalShare"
      @close="toggleModalShare"
      :title="`${localization('Share your PLP')}`"
      @submit="submitShared"
      :description="`${localization('Share your personalized work profile and learning patterns score with others to let them know how you learn, work, and interact with others.')}`"
    ></ShareModal>
    <!--  End Share -->
  </div>
</template>

<script>
import Swal from "sweetalert2";
export default {
  name: "Profile View",
  data() {
    return {
      showHideModalUserType: false,
      panel: [`Precision`, `Sequence`, "Technical Reasoning", "Confluence"],
      loading: false,
      fileList: [],
      selected: [],
      statementId: null,
      statementDialogVisible: false,
      statementTitle: null,
      task: {
        name: "",
        topic_id: "",
        description: ""
      },
      task2: {
        name: "",
        topic_id: "",
        description: ""
      },
      rules: {
        name: [
          {
            required: true,
            message: this.localization("Please enter the task name"),
            trigger: "blur"
          }
        ],
        topic_id: [
          {
            required: true,
            message: this.localization("Please enter the task topic"),
            trigger: "blur"
          }
        ],
        description: [
          {
            required: true,
            message: this.localization("Please enter a task description"),
            trigger: "blur"
          }
        ]
      },
      rules2: {
        name: [
          {
            required: true,
            message: this.localization("Please enter the task name"),
            trigger: "blur"
          }
        ],
        topic_id: [
          {
            required: true,
            message: this.localization("Please enter the task topic"),
            trigger: "blur"
          }
        ],
        description: [
          {
            required: true,
            message: this.localization("Please enter a task description"),
            trigger: "blur"
          }
        ]
      },
      dialogVisible: false,
      dialogVisible2: false,
      showHideModalAddStatement: false,
      statementName: "",
      payload: {
        title: "",
        type: "",
        pattern: ""
      },
      showHideModalShare: false
    };
  },
  watch: {
    '$route'(to, from) {
      this.getMainUserData();
    }
  },
  computed: {
    mainUserId() {
      return this.$route.params.id ? this.$route.params.id : this.auth().id;
    },
    userScore() {
      return this.$store.getters["user/score"];
    },
    userAttributes() {
      return this.$store.getters["user/attrs"];
    },
    isAuthEqualUser() {
      return this.auth().id == this.mainUserId;
    },
    userData() {
      return this.$store.state.user.user;
    },
    standardTopicsData() {
      return this.$store.getters["topics/getStandardTopics"];
    },
    atWorkTasksTopics() {
      return this.$store.getters["user/getAtWorkTasksTopics"];
    },
    image() {
      if (this.userData.image) {
        return `${process.env.VUE_APP_BASE_URL}/users/photo/${this.userData.image}`;
      }
      return "/static/img/lml-swerl.jpg";
    }
  },
  methods: {
    // Get User Data And Set User Score
    getMainUserData() {
      this.$store.dispatch("user/user", this.mainUserId).then(() => {
        // Set the Selected User attribute
        this.selected = this.userData.selected_attributes;
        if(this.userData.sequence){
        }else {
          this.$router.push( '/new-theme/instructions' )
        }
      });
    },
    resetStatementForm(){
      this.payload = {
        title: "",
        type: "",
        pattern: ""
      }
      this.statementDialogVisible = false
    },
    deleteCustomAttribute(id){
      Swal.fire({
        title: "",
        text: `${this.localization("Are You Sure")}`,
        type: "warning",
        icon: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success ",
        cancelButtonClass: "btn btn-danger ",
        confirmButtonText: `${this.localization("Delete")}`,
        cancelButtonText: `${this.localization("Cancel")}`,
        buttonsStyling: false
      }).then(date => {
        if (date.isConfirmed) {
          let payload = {
            tasks: this.selected
          };
          this.$store.dispatch("user/delete_custom_attribute_profile", id ).then(_ => {
          this.getMainUserData();
            Swal.fire({
              title: "",
              icon: "success",
              type: "success",
              text: `${this.localization("Deleted")}`,
              confirmButtonText: `${this.localization("Ok")}`,
              confirmButtonClass: "btn btn-success ",
              buttonsStyling: false
            });
          });
        }
      });
    },
    ToggleStatementModalForEdit(item){
      this.statementId = item.id
      this.payload.title = item.title
      this.payload.pattern = item.pattern
      this.payload.type = item.type
      this.statementDialogVisible = true
    },
    submitStatementForm(){
      this.$store
      .dispatch("user/edit_custom_attribute", {id: this.statementId, payload: this.payload} )
      .then(() => {
        this.getMainUserData();
        this.payload.title = "";
        this.payload.type = "";
        Swal.fire({
          icon: "success",
          text: `${this.localization("Done")}`,
          confirmButtonText: `${this.localization("Ok")}`,
          type: "success",
          confirmButtonClass: "btn btn-success ",
          buttonsStyling: false
        });
      });
      this.statementDialogVisible = false
    },
    handleUploadSuccess(file, fileList) {
      this.fileList = fileList;
      this.handle_upload_file_img(file);
    },
    handleRemove(file, fileList) {
      this.fileList = [];
    },
    ToggleTaskModal() {
      this.dialogVisible = !this.dialogVisible;
    },
    ToggleTaskModal2() {
      this.dialogVisible2 = !this.dialogVisible2;
    },
    resetForm() {
      this.$refs.taskForm.resetFields();
      this.fileList = [];
      this.dialogVisible = false;
      // this.$v.$reset();
    },
    resetForm2() {
      this.$refs.taskForm2.resetFields();
      this.fileList = [];
      this.dialogVisible2 = false;
      // this.$v.$reset();
    },
    submitForm() {
      this.$refs.taskForm.validate(valid => {
        if (valid) {
          this.$store
            .dispatch("user/add_task", {
              query: this.task
            })
            .then(response => {
              this.dialogVisible = false;

              Swal.fire({
                title: "",
                icon: "success",
                text: `${this.localization("Done")}`,
                confirmButtonText: `${this.localization("Ok")}`,
                type: "success",
                confirmButtonClass: "btn btn-success ",
                buttonsStyling: false
              });

              this.$router.push(`/new-theme/tasks/${response.task.id}`);
            })
            .catch(_ => {
              this.dialogVisible = false;
            });

          // Implement strategy generation logic
        } else {
          // this.$message.success("Form is valid. Strategies will be generated.");
          // this.$message.error("Please fill out all required fields.");
          return false;
        }
      });
    },
    submitForm2() {
      this.$refs.taskForm2.validate(valid => {
        if (valid) {
          this.$store
            .dispatch("user/handleAddWorkTask", {
              query: this.task2
            })
            .then(response => {
              this.dialogVisible2 = false;

              Swal.fire({
                title: "",
                icon: "success",
                text: `${this.localization("Done")}`,
                confirmButtonText: `${this.localization("Ok")}`,
                type: "success",
                confirmButtonClass: "btn btn-success ",
                buttonsStyling: false
              });

              this.$router.push(`/new-theme/at-work/${response.task.id}`);
            })
            .catch(_ => {
              this.dialogVisible2 = false;
            });
        } else {
          // this.$message.success("Form is valid. Strategies will be generated.");
          // this.$message.error("Please fill out all required fields.");
          return false;
        }
      });
    },
    beforeUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error("File size cannot exceed 5MB.");
      }
      return isLt5M;
    },
    getProgressColor(key) {
      switch (key) {
        case "Precision":
          return "#3c3";
        case "Technical Reasoning":
          return "#f93";
        case "Confluence":
          return "#c36";
        case "Sequence":
          return "#39c";
      }
    },

    // Toggle Modal User Type
    toggleModalUserType() {
      this.showHideModalUserType = !this.showHideModalUserType;
    },
    // Toggle Modal User Type
    toggleModalAddStatement(statementName = "", attribute = []) {
      this.showHideModalAddStatement = !this.showHideModalAddStatement;
      this.statementName = statementName;
      this.payload.pattern = statementName;
      if (attribute.length > 0) {
        this.payload.type = attribute[0].type;
      }
    },
    // updateSelectedAttributes(checked, itemId) {

    //   if (checked) {
    //     if (!this.selected.includes(itemId)) {
    //       this.selected.push(itemId);
    //     }
    //   } else {
    //     this.selected = this.selected.filter(id => id !== itemId);
    //   }


    //   // Dispatch Vuex action with updated selected attributes
    //   this.$store
    //     .dispatch("user/update_attribute", {
    //       id: this.mainUserId,
    //       query: { selected_attributes: this.selected }
    //     })
    //     .then(() => {
    //     })
    //     .catch(err => {
    //       console.error("Error updating attributes:", err);
    //     });
    // },
    updateSelectedAttributes(checked, itemId) {
      // Defensive check
      if (!Array.isArray(this.selected)) {
        this.selected = [];
      }

      if (checked) {
        if (!this.selected.includes(itemId)) {
          this.selected.push(itemId);
        }
      } else {
        this.selected = this.selected.filter(id => id !== itemId);
      }

      this.$store
        .dispatch("user/update_attribute", {
          id: this.mainUserId,
          query: { selected_attributes: this.selected }
        })
        .catch(err => {
          console.error("Error updating attributes:", err);
        });
    },
    printPlp() {
      window.print();
        // this.$store.dispatch("user/print_plp").then(() => {
        //   Swal.fire({
        //     title: "",
        //     text: `${this.localization("Done")}`,
        //     confirmButtonText: `${this.localization("Ok")}`,
        //     icon: "success",
        //     confirmButtonClass: "btn btn-success",
        //     buttonsStyling: false
        //   });
        //   this.showHideModalShare = false;

        // });

    },
    text_speech_audio(any_text) {
      this.$store
        .dispatch("user/get_text_to_speech_audio", { text: any_text })
        .then(res => {
          let audioBlob = new Blob([res], { type: "audio/mpeg" });
          let audioURL = URL.createObjectURL(audioBlob);
          let audio = document.getElementById("audio");
          var source = document.getElementById("audio-source");
          source.src = audioURL;
          audio.load();
          audio.play();
        });
    },
    addCustomAttribute() {
      this.showHideModalAddStatement = !this.showHideModalAddStatement;
      this.$store
        .dispatch("user/add_custom_attribute", this.payload)
        .then(() => {
          this.getMainUserData();
          this.payload.title = "";
          this.payload.type = "";
          Swal.fire({
            icon: "success",
            text: `${this.localization("Done")}`,
            confirmButtonText: `${this.localization("Ok")}`,
            type: "success",
            confirmButtonClass: "btn btn-success ",
            buttonsStyling: false
          });
        });
    },
    // Toggle Modal User Type
    toggleModalShare() {
      this.showHideModalShare = !this.showHideModalShare;
    },
    // Return pattern key in collapse
    patternKey(name) {
      if (name == "Sequence") {
        // Start Pattern range
        if (this.userScore?.sequence >= 25 && this.userScore.sequence <= 35) {
          return "Use First";
        } else if (
          this.userScore?.sequence >= 7 &&
          this.userScore.sequence <= 17
        ) {
          return "Avoid";
        } else if (
          this.userScore?.sequence >= 18 &&
          this.userScore.sequence <= 24
        ) {
          return "As Needed";
        }
        // End Pattern range
      }
      if (name == "Precision") {
        // Start Pattern range
        if (this.userScore?.precision >= 25 && this.userScore.precision <= 35) {
          return "Use First";
        } else if (
          this.userScore?.precision >= 7 &&
          this.userScore.precision <= 17
        ) {
          return "Avoid";
        } else if (
          this.userScore?.precision >= 18 &&
          this.userScore.precision <= 24
        ) {
          return "As Needed";
        }
        // End Pattern range
      }
      if (name == "Technical Reasoning") {
        // Start Pattern range
        if (
          this.userScore?.technical_reasoning >= 25 &&
          this.userScore.technical_reasoning <= 35
        ) {
          return "Use First";
        } else if (
          this.userScore?.technical_reasoning >= 7 &&
          this.userScore.technical_reasoning <= 17
        ) {
          return "Avoid";
        } else if (
          this.userScore?.technical_reasoning >= 18 &&
          this.userScore.technical_reasoning <= 24
        ) {
          return "As Needed";
        }
        // End Pattern range
      }
      if (name == "Confluence") {
        // Start Pattern range
        if (
          this.userScore?.confluence >= 25 &&
          this.userScore.confluence <= 35
        ) {
          return "Use First";
        } else if (
          this.userScore?.confluence >= 7 &&
          this.userScore.confluence <= 17
        ) {
          return "Avoid";
        } else if (
          this.userScore?.confluence >= 18 &&
          this.userScore.confluence <= 24
        ) {
          return "As Needed";
        }
        // End Pattern range
      }
    },


    submitShared(sharedEmails) {

      let payload = {
        emails: sharedEmails
      };

      this.$store.dispatch("user/share_plp_task_attributes", payload).then(() => {
        Swal.fire({
          title: "",
          text: `${this.localization("Done")}`,
          confirmButtonText: `${this.localization("Ok")}`,
          icon: "success",
          confirmButtonClass: "btn btn-success",
          buttonsStyling: false
        });
        this.showHideModalShare = false;
        // this.$router.push({name:'Personalize Your Profile plp'})
      });
    }
  },
  mounted() {
    this.$store.dispatch("topics/handlerStandardTopics");
    this.$store.dispatch("user/handlerWorkTopics");
    this.getMainUserData();
  }
};
</script>

<style lang="scss" scoped>
.main_profile_wrapper {
  background: #fff;
  width: 100%;
  max-width: 100%;
  padding: 0 30px 50px;

  .main_title {
    color: #101828;
    font-weight: 600;
    font-size: 20px;
    &.white_text {
      color: #fff;
    }
  }

  // Use Your Learning Patterns
  .learner_patterns_wrapper {
    margin-top: 40px;
    .titles_wrap {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .print_share_buttons {
        display: flex;
        align-items: center;
        gap: 10px;
      }
    }
    .btn_2 {
      border: none;
      color: #6941c6;
      font-size: 16px;
      height: 41px;
      padding: 10px 16px;
      display: flex;
      align-items: center;
      font-weight: 500;
      gap: 10px;
      background: transparent;
      transition: 0.3s;
      &:hover {
        opacity: 0.7;
      }
    }
    .text {
      color: #7f8b9e;
      font-weight: 400;
      font-size: 16px;
      margin-top: 4px;
    }
    .main_cards {
      display: flex;
      justify-content: flex-start;
      gap: 24px;
      flex-wrap: wrap;
      margin-top: 32px !important;

      .card_item {
        background: #ffffff;
        border-radius: 12px;
        border: 1px solid #eaecf0;
        box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
        padding: 32px 24px;
        width: calc((100% - 48px) / 3);
        display: flex;
        flex-direction: column;

        @media (max-width: 1200px) {
          width: calc((100% - 24px) / 2);
        }
        @media (max-width: 768px) {
          width: 100%;
        }

        .icon_img {
          width: 56px;
          height: 56px;
          object-fit: contain;
          margin-bottom: 8px;
        }

        .title {
          color: #101828;
          font-weight: 600;
          font-size: 18px;
          margin-bottom: 8px;
        }
        .description {
          color: #667085;
          font-weight: 400;
          font-size: 16px;
          line-height: 24px;
        }
        .lci_btn {
          background-color: #f9f5ff;
          color: #6941c6;
          border-radius: 8px;
          padding: 12px 20px;
          border: none;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          width: 100%;
          font-weight: 600;
          font-size: 16px;
          margin-top: auto;
          transition: 0.3s;
          &:hover {
            background-color: #f4ebff;
          }
          img {
            filter: invert(28%) sepia(85%) saturate(1905%) hue-rotate(245deg) brightness(85%) contrast(90%);
          }
        }
      }

      &.two_cards {
        .card_item {
          width: calc((100% - 24px) / 2);
          @media (max-width: 768px) {
            width: 100%;
          }
        }
      }
    }
  }
  // Start Personalize your profile & Collapse Items
  .main_profile_personalize_and_collapse {
    .description {
      color: #667085;
      font-weight: 400;
      font-size: 16px;
    }
    .customization_for_collapse {
      .main_child {
        padding: 20px;
        // border: 2px solid #ccc;
        margin-bottom: 30px;
        border-radius: 16px;
      }
      .el-collapse-item__header {
        padding: 2.5rem 0;
        @media print {
          // padding: 1.5rem 0;
        }
      }

      .custom_header_of_collapse {
        width: 100%;
        border-bottom: 1px solid #eaecf0;
        .title_word {
          margin: 0 10px;
          color: #344054;
        }
      }
      .collapse_checkboxes {
        .checkboxes_wrapper {
          margin-bottom: 15px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .span_img_wrapper {
            border: 1px solid #d0d5dd;
            border-radius: 6px;
            height: 32px;
            width: 32px;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
      }
      .your_own_statement {
        border-top: 1px solid #eaecf0;
        padding: 24px 0;
        display: flex;
        align-items: center;
        gap: 10px;
        font-weight: 500;
        color: #6941c6;
      }
      // .el-collapse-item .el-collapse-item__content {
      //   box-shadow: none !important;
      //   border: none !important;
      // }
    }
  }
  // End Personalize your profile & Collapse Items

  // Start How to use your Personal Learning Profile (PLP)?
  .how_to_use {
    .print_share_buttons {
      display: flex;
      align-items: center;
      gap: 2%;

      @media (max-width: 576px) {
        flex-direction: column;
        gap: 10px;
      }
    }
    .btn_2 {
      border: 1px solid #6941c6;
      border-radius: 8px;
      color: #6941c6;
      font-size: 14px;
      height: 41px;
      padding: 10px 16px;
      display: flex;
      align-items: center;
      font-weight: 500;
      gap: 10px;
      background: #fff;
      width: calc(98% / 2);
      justify-content: center;
      transition: 0.3s;

      &:hover {
        background-color: #6941c6;
        color: #fff;
      }

      @media (max-width: 576px) {
        width: 100%;
      }
    }
  }
  // End How to use your Personal Learning Profile (PLP)?

  .color {
    color: #6941c6;
  }

  .lci_modal_buttons {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 3%;
    .lci_btn,
    .lci_btn_modal_cancel {
      background-color: #fff;
      color: #667085;
      border-radius: 8px;
      padding: 12px 20px;
      border: 1px solid #eaecf0;
      width: calc(97% / 2);
    }
    .lci_btn {
      background-color: #f2f4f7;
      &.save {
        background-color: #6941c6;
        color: #fff;
      }
    }
  }
  .statement_modal {
    .desc2 {
      color: #344054;
      font-weight: 500;
      font-size: 16px;
    }
    .text_area {
      border: 1px solid #d0d5dd;
      height: 92px;
      width: 100%;
      resize: none;
      border-radius: 8px;
      color: #101828;
      padding: 15px;
      outline: none;
      word-break: break-word;
    }
  }
}

.user_modal {
  padding: 0;
  .el-dialog__header {
    display: none !important;
  }
  .user_modal_type {
    .modal_title {
      color: #101828;
      margin-top: 20px;
      margin-bottom: 10px;
      font-weight: 500;
      font-size: 18px;
    }
    .description_type {
      .text_type {
        color: #667085;
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
        word-break: break-word;
      }
    }

    .copy_wrapper {
      border: 1px solid #d0d5dd;
      display: flex;
      align-items: center;
      justify-content: space-between;
      overflow: hidden;
      border-radius: 8px;
      .input_link {
        border: none;
        outline: none;
        padding: 0 10px;
        height: 44px;
        flex-grow: 1;
      }
      .span_wrap {
        padding: 0 10px;
        height: 44px;
        border-left: 1px solid #d0d5dd;
        width: 107px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
      }
    }


  }
}
</style>

<style lang="scss">
.user_modal {
  padding: 0;
  .el-dialog__header {
    display: none !important;
  }
}

.main_profile_personalize_and_collapse {
  .el-collapse {
    border: none !important;
  }
  .el-collapse-item__content {
    box-shadow: none !important;
    border: none !important;

    // @media print {
    //   padding-bottom: 0;
    // }
  }
  .el-collapse-item__wrap {
    border-bottom: none !important;
  }
  .el-collapse-item__content {
    padding-bottom: 0;
    font-size: 16px;
    line-height: inherit;
    color: #344054 !important;
  }
  .el-checkbox__inner {
    border: 1px solid #d0d5dd;
    border-radius: 6px;
    height: 20px;
    width: 20px;
  }
  .el-checkbox {
    align-items: flex-start;
    display: flex;
  }
  .el-checkbox__label,
  .el-checkbox is-checked {
    color: #344054 !important;
    font-weight: 400;
    font-size: 16px;

    // max-width: 98%;
    word-break: break-word !important;
    white-space: pre-wrap;
    // word-wrap: break-word;
    white-space: normal;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #6941c6;
    border-color: #6941c6;
  }
  .el-checkbox__inner::after {
    left: 7px;
    top: 4px;
    border-width: 2px;
  }
}
::v-deep .input_with_custom_text_area .el-textarea__inner {
  word-break: break-word !important; /* Ensures long words break */
  overflow-wrap: break-word !important; /* Ensures text wraps properly */
  white-space: pre-wrap !important; /* Preserves line breaks */
}

</style>
